import { render, staticRenderFns } from "./TextModuleOverview.vue?vue&type=template&id=64c546fc"
import script from "./TextModuleOverview.vue?vue&type=script&lang=js"
export * from "./TextModuleOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports